<dx-toolbar *ngIf="user" >
<dxi-item location="after"
  widget="dxDropDownButton"

  [options]="{icon: 'im im-user-circle',
  text: this.currentUser !== null ? this.currentUser.nombre : '',
  items: itemsUsuario,
  displayExpr: 'name',
  keyExpr: 'value',
  stylingMode: 'text',
  onItemClick: onItemClickUsario }"
  >
</dxi-item>
</dx-toolbar>
<!-- <dx-drawer *ngIf="user"
  [openedStateMode]="selectedOpenMode"
  [position]="selectedPosition"
  [revealMode]="selectedRevealMode"
  template="template"
  [(opened)]="isDrawerOpen"
  height="auto"
  [closeOnOutsideClick]="false"
>
  <div *dxTemplate="let data of 'template'" style="width: 200px">
    <dx-list
    class="drawer-list"
    [dataSource]="navigation"
    [hoverStateEnabled]="false"
    [activeStateEnabled]="false"
    [focusStateEnabled]="false"
    (onItemClick)="onItemClick($event)"
    >
    </dx-list>
  </div> -->
   <!-- content -->
   <!-- <div id="content" class="dx-theme-background-color"> -->

    <!-- main -->
    <main role="main">
      <router-outlet></router-outlet>
    </main>
    <!-- main end -->
<!-- </div> -->
<!-- content -->
<!-- </dx-drawer> -->



<!-- login -->
<div *ngIf="!user">
  <main role="main">
    <router-outlet></router-outlet>
  </main>
</div>
<!-- login end -->
